import { useCallback } from 'react';

import { useCustomerActions, useUserActions, useWorkspaceActions } from '../store';

export const useGetCommonEventAuthAttributes = () => {
  const userActions = useUserActions();
  const customerActions = useCustomerActions();
  const workspaceActions = useWorkspaceActions();

  return useCallback(() => {
    const user = userActions.getCurrentUser();

    return {
      userId: user?.id,
      customerId: customerActions.getCurrentCustomerId(),
      workspaceId: workspaceActions.getCurrentWorkspaceId(),
    };
  }, [userActions, customerActions, workspaceActions]);
};
